var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37958 6.21143C11.0854 10.1379 15.8221 13.7033 20.9595 17.0388C22.9861 18.3545 24.9221 19.7744 26.8551 21.2218C27.7692 21.9063 28.71 22.5218 29.4567 23.3929",
    stroke: "#FF782C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0985 4.02148C25.2688 6.19969 23.3106 8.44138 21.1561 10.3008C18.7499 12.3773 16.6894 14.7169 14.1094 16.5894C13.0018 17.3934 12.0003 18.2719 10.9651 19.1629C9.83105 20.139 8.51314 20.8528 7.409 21.858C6.34924 22.8229 5.10271 23.6107 4.02136 24.5719",
    stroke: "#FF782C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.139C3.94463 15.6409 6.00648 15.4759 7.99855 15.4759C10.3129 15.4759 12.6196 15.336 14.9329 15.3075C17.9357 15.2704 21.045 15.223 24.029 14.8583C25.1855 14.7169 26.2331 14.3482 27.3979 14.2968C28.4473 14.2505 29.4281 13.7616 30.4674 13.623C31.0567 13.5444 31.6842 13.5358 32.2641 13.4171C33.0077 13.265 33.5678 13.1177 34.3416 13.1177",
    stroke: "#FF782C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9917 2C16.5121 8.17496 16.8232 14.4488 16.8232 20.6414C16.8232 22.2728 16.8232 23.9042 16.8232 25.5357C16.8232 26.1881 16.6158 27.2084 16.9917 27.7722",
    stroke: "#FF782C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.a4eb8cd403565274b8bb28d4183177fb.svg";
export { ForwardRef as ReactComponent };